import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Home.css";

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if(token && role)
      {
        if (role === "user") {
          navigate("/user-tickets");
        } else {
          navigate("/ticket-manager");
        }
      }
  }, [navigate]);

  return (
    <>
      {/* Navbar */}
      <nav
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 20px",
          backgroundColor: "#000000",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        {/* left side of navbar */}
        <Link
          to="/"
          style={{
            fontWeight: "600",
            fontSize: "18px",
            color: "#ffffff",
            textDecoration: "none",
          }}
        >
          FixTrack
        </Link>

        {/* right side of navbar */}
        <div style={{ display: "flex", gap: "16px" }}>
          <Link
            to="/login"
            style={{
              textDecoration: "none",
              color: "#ffffff",
            }}
          >
            Login
          </Link>
        </div>
      </nav>

      {/* Main page content */}
      <section className = "main">
      <div className="main-content">
        <h1>Welcome to FixTrack</h1>
          <p>
            Modern help desk system designed to manage support tickets and keep teams organized.
          </p>
        <Link to="/login" className="main-button">
          Get Started
        </Link>
      </div>

      <div className="main-image">
        <img src="/ticket-support.png" alt="Support Ticket Image" />
      </div>
      </section>

      {/* Feature Section*/}
    <section className="features">
      <div className="features-container">
        <div className="feature-card">
          <h3>Create Tickets</h3>
          <p>Users can quickly submit requests.</p>
        </div>

        <div className="feature-card">
          <h3>Track Progress</h3>
          <p>Follow ticket progress and communicate with technicians.</p>
        </div>

        <div className="feature-card">
          <h3>Resolve Issues</h3>
          <p>Admins and technicians can manage and resolve tickets efficiently.</p>
        </div>
      </div>
</section>

      
    </>
  );
}
